import { render, staticRenderFns } from "./StocktakingMenu.vue?vue&type=template&id=c4344c9e&"
import script from "./StocktakingMenu.vue?vue&type=script&lang=js&"
export * from "./StocktakingMenu.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingMenu.vue?vue&type=style&index=0&id=c4344c9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports